export function section1031ExchangeAddendum2027() {
return [   // Release 2026-10-02 11:31:34
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 340.342,
   left: 92.64,
   width: 438.00,
   height: 13.778
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 367.102,
   left: 144.0,
   width: 162.0,
   height: 13.778
}
,
{
   page: 0,
   name: "Checkbox Buyer1", 
   isText: false,
   type: "checkbox",
   top: 441.166,
   left: 93.9459,
   width: 10.0801,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Seller is Exchanging Party", 
   isText: false,
   type: "checkbox",
   top: 439.856,
   left: 181.964,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Buyer2", 
   isText: false,
   type: "checkbox",
   top: 454.911,
   left: 93.9459,
   width: 10.0801,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Seller is Cooperating Party", 
   isText: false,
   type: "checkbox",
   top: 454.911,
   left: 181.964,
   width: 10.080,
   height: 10.080
}
] }
